// showWelcomeToastr.js
'use strict';
import { push } from '../action/navigationAction.js';
import pushToastr from '../action/pushToastr.js';
import removeModals from '../action/removeModals.js';
import i18n from '../resource/i18n.js';
import { ButtonId, ModalId } from '../resource/trackingConstants.js';
import { login as loginModal } from '../resource/modalId.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import getIsPermissionMatched from '../selector/getIsPermissionMatched.js';
import { JWT_SCOPE_GUEST } from '../RemoteConfigKeys.js';

const showWelcomeToastr =
  ({ isWebAuthnBound } = {}) =>
  async (dispatch, getState) => {
    // Guest accounts shouldn't be prompted to set up passkey.
    if (getIsPermissionMatched(getState(), JWT_SCOPE_GUEST)) {
      return dispatch({ type: '' });
    }

    const ns = TranslationNamespace.NOTIFICATION;
    // NOTIFICATION namespace is lazy-loaded; trigger fetch and wait below so the
    // toastr can display the correct translated content.
    i18n.t('passkey_setup_now', { ns });

    if (!i18n.customExists?.('passkey_setup_now', { ns })) {
      await new Promise(resolve => {
        const handler = (_language, addedNamespace) => {
          if (addedNamespace !== ns) return;
          i18n.store?.off('added', handler);
          clearTimeout(timer);
          resolve();
        };
        i18n.store?.on('added', handler);
        const timer = setTimeout(resolve, 3000);
      });
    }

    if (isWebAuthnBound) {
      return dispatch(
        pushToastr({
          textKey: 'toast_signup_success',
          durationSec: 3,
        })
      );
    }

    return dispatch(
      pushToastr({
        textKey: 'toast_signup_success',
        content: i18n.t('passkey_setup_prompt_subtitle', { ns }),
        type: 'success',
        trackingModalId: ModalId.LoginSignup.PasskeySetUpReminder,
        primaryButton: {
          text: i18n.t('passkey_setup_now', { ns }),
          trackingId: ButtonId.LoginRegister.ButtonEnableNow,
          onClick: () => {
            dispatch(
              removeModals({
                ids: [loginModal.AGE_VERIFICATION_PHONE],
                transitionStatus: 'reversing',
              })
            );
            dispatch(push('/manage-profile/account-linking/web-authn'));
          },
        },
        secondaryButton: {
          text: i18n.t('passkey_setup_later', { ns }),
          trackingId: ButtonId.LoginRegister.ButtonEnableLater,
          onClick: () => {},
        },
      })
    );
  };

export default showWelcomeToastr;
